export default __webpack_public_path__ + "static/media/BestAccessibility2023.124d1a36.png";